module.exports = __webpack_public_path__ + "img/bicing.66f2bc89.svg";